export const removefileExtensionFromFileName = fileName => fileName && fileName.substring(0, fileName.lastIndexOf('.')) || '';